export const SET_FUNDS_TRANSFER_CONFIG = 'SET_FUNDS_TRANSFER_CONFIG';

export const setFundsTransferConfig = fundsTransferConfig => ({
    type: SET_FUNDS_TRANSFER_CONFIG,
    payload: fundsTransferConfig
});

